export enum SkinnyBannerWidgetType {
  SkinnyBanner = 'skinnyBannerWidget',
  SkinnyBannerPage = 'skinnybanner',
}
